var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.071 4.7571L4.464 15.3641L0.929001 16.0711L1.636 12.5361L12.243 1.9291M15.071 4.7571C15.4353 4.3799 15.6369 3.87469 15.6323 3.3503C15.6278 2.8259 15.4175 2.32428 15.0466 1.95346C14.6758 1.58265 14.1742 1.37231 13.6498 1.36775C13.1254 1.36319 12.6202 1.56478 12.243 1.9291M15.071 4.7571L13.657 6.1721L10.828 3.3431L12.243 1.9291",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3449faf2f67a8538043a91ea5aa6eccf.svg";
export { ForwardRef as ReactComponent };